{
  "codeExpired": "Il codice inserito è scaduto.",
  "codeInvalid": "Il codice inserito non è valido. Controlla nuovamente e riprova.",
  "decimalNumber": "Questo campo deve essere un numero.",
  "deviceLocationUnknown": "Posizione del dispositivo sconosciuta.",
  "integerOnly": "Questo campo deve essere un numero intero.",
  "maxLengthWithVal": "Troppi caratteri (massimo {{val}})",
  "maxValueWithVal": "Questo valore deve essere minore o uguale a {{val}}.",
  "minLength": "deve contenere almeno {{minLength}} caratteri.",
  "minValueWithVal": "Questo valore deve essere almeno {{val}}.",
  "passwordRulesLowercaseCount": "La password deve contenere almeno una lettera minuscola.",
  "passwordRulesMinLength": "La password deve essere lunga almeno 8 caratteri.",
  "passwordRulesMustMatch": "Le password devono essere identiche.",
  "passwordRulesNumericCount": "La password deve contenere almeno un numero.",
  "passwordRulesSpecialCharacterCount": "La password deve contenere almeno un carattere speciale (!@#$$^&*)",
  "passwordRulesUppercaseCount": "La password deve contenere almeno una lettera maiuscola.",
  "required": "Questo campo è obbligatorio."
}
